import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { FullLoaderService } from 'src/app/core/services/full-loader.service';
import { SnackBarService } from 'src/app/core/services/snack-bar.service';
import { PigeonholePositionInfo } from 'src/models/Pigeonhole';
import { PigeonholeService } from 'src/app/core/data-sources/v3/pigeonhole/pigeonhole.service';

@Component({
  selector: 'app-pigeonhole-page',
  templateUrl: './pigeonhole-page.component.html',
  styleUrls: ['./pigeonhole-page.component.scss']
})
export class PigeonholePageComponent implements OnInit {
  map;
  positionInfo: PigeonholePositionInfo;
  isMapLoaded: boolean;
  notificationAlreadyOpen = false;
  notificationData: {
    type: string,
    title: string,
    message: string
  };
  id: string = null;
  openTip = false;
  @ViewChild('notification', { static: true }) notificationTmpl;
  private destroy$ = new Subject();

  @HostListener('wheel', ['$event']) preventZoomOnWHeel(event: WheelEvent) {
    if (event.ctrlKey || event.metaKey) {
      event.preventDefault();
    }
  }

  @HostListener('window:keydown', ['$event']) preventZoomOnCtrlPlus(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && (event.key === '+' || event.key === '-' || event.key === '=')) {
      this.openFeedbackOnce();
      event.preventDefault();
    }
  }

  constructor(
    private router: Router,
    public fullLoaderService: FullLoaderService,
    private snackbarService: SnackBarService,
    private activatedRoute: ActivatedRoute,
    private pigeonholeService: PigeonholeService
  ) { }

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.fullLoaderService.open();
    this.getMap().then(() => { }).catch((err) => console.log(err));
    this.getPositionInfo();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async getPositionInfo() {
    this.positionInfo = await this.pigeonholeService.getPigeonholePositionInfo(this.id);
  }

  async getMap() {
    this.map = await this.pigeonholeService.getPigeonholePositionMap(this.id);
    return this.map;
  }

  navigateToMap() {
    this.router.navigate(['map']);
  }

  mapLoaded() {
    this.isMapLoaded = true;
    this.closeLoader();
  }

  closeLoader() {
    if (this.map && this.isMapLoaded) {
      this.fullLoaderService.close();
    }
  }

  openFeedbackOnce(): void {
    if (this.notificationAlreadyOpen) {
      return;
    }
    this.notificationAlreadyOpen = true;
    this.openTip = true;
    this.notificationData = {
      type: 'warning',
      title: 'ATENÇÃO',
      message: 'Para dar zoom, utilize o scroll do mouse.'
    };
    this.snackbarService.showFeedback(this.notificationTmpl, this.notificationData, '1');
    setTimeout(() => {
      this.snackbarService.hideNotification('1');
      this.notificationAlreadyOpen = false;
    }, 5000);
  }

  showLoader(show: boolean) {
    if (show) {
      this.fullLoaderService.open();
    } else {
      this.fullLoaderService.close();
    }
  }

}
